<template>
  <customModal :containerxxl="true" @closeModal="closeModal()">
    <template #title>
      View Form
    </template>
    <template #body>
      <div class="ibox-content p-0">
        <div class="form-group row col-md-12">
          <div class="d-flex flex-column flex-lg-row my-1">
            <div class="form-group mb-0 w-100 pr-1">
              <label class="mb-0">{{ $t('navigations.site code') }}:</label>
              <h4>{{ patientdetails.siteCode }}</h4>
            </div>
            <div class="form-group mb-0 w-100 pr-1">
              <label class="mb-0">{{ $t('navigations.subject id') }}:</label>
              <h4>{{ patientdetails.subjectId }}</h4>
            </div>
            <!-- <div class="form-group mb-0 w-100 pr-1">
              <label class="mb-0">{{ $t("navigations.visit name") }}</label> <sup><i
                  class="fa fa-asterisk imp"></i></sup>
              <select class="form-select my-2 my-lg-0" name="account" v-model="selectedvisit">
                <option disabled value="">--Select--</option>
              <option v-for="visit in visits" :key="visit.visitNo" :value="visit.visitNo">
  {{ visit.visitName }}
</option>

              </select>
            </div> -->
            <div class="form-group mb-0 w-100 pr-1">
  <label class="mb-0">Visit</label> <sup><i class="fa fa-asterisk imp"></i></sup>
  <select class="form-select my-2 my-lg-0"
          v-model="selectedvisit"
          @change="listSOAs(siteId, subjectidpassed, selectedvisit.visitNo)">
    <option disabled value="">--Select--</option>
    <option v-for="visit in visits" :key="visit.visitNo" :value="visit">
      {{ visit.visitName }}
    </option>
  </select>
</div>
       <div class="form-group mb-0 w-100 pr-1">
  <label class="mb-0">Activity</label> <sup><i class="fa fa-asterisk imp"></i></sup>
  <select class="form-select my-2 my-lg-0" v-model="selectedactivity"
   @change="getFormsByVisit()">
    <option disabled value="">--Select--</option>
    <option v-for="activity in SoAList" :key="activity.activityId" :value="activity">
      {{ activity.activityName }}
    </option>
  </select>
</div>
          <div class="form-group mb-0 w-100 pr-1">
            <label class="mb-0">Forms</label> <sup><i class="fa fa-asterisk imp"></i></sup>
            <select class="form-select my-2 my-lg-0" v-model="selectedform" @change="getFormsByVisit()">
              <option disabled value="">--Select--</option>
              <option v-for="form in TemplateList" :key="form.activityId" :value="form">
                {{ form.templateName }}
              </option>
            </select>
          </div>

            <div class="col-12 col-md-2 px-0 px-md-1 align-self-end">
              <span type="button" class="save_btn w-100" @click.prevent="isScheduled(selectedsubject)">
                {{ $t('navigations.map form') }}
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex">
        <div class="col-lg-12">
        <div v-if="currentformstatus == 'Completed'" class="modal-body setheightandwidth pb-0">
          <showForm :formsesid="formid" :detaileddescription="false" :isfieldvalidate=false :isqueryfield=false
            :requiredsubmit='false' closedoption='displayform' />
        </div>
        <div v-else class="modal-body setheightandwidth pb-0">
          <viewForm :formsesid="formid" :closedoption="false" templatebasedon="study">
          </viewForm>
        </div>
      </div>
      </div>
      </div>
    </template>
  </customModal>
</template>
<script>
import { useI18n } from "vue-i18n";
import store from "../../store/index";
import axios from "axios";
import customModal from "../customModal/customModal.vue";
export default {
  setup() {
    const { t, locale } = useI18n({ useScope: "global" });
    return { t, locale };
  },
  props: {
    formid: {
      type: String,
      default: "",
    },
    scheduleId: {
      type: String,
      required: true,
    },

    currentformstatus: {
      type: String,
      default: "Completed",
    },
    subjectidpassed: {
      type: String,
      default: "",
    },
  },
  components: {
    customModal
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      sites: [],
      TemplateList: [],
      subjects: [],
      visits: [],
      SoAList: [],
      selectedsubject: "",
      selectedsite: "",
      selectedvisit: "",
      selectedactivity: "",
      patientdetails: {}
    };
  },
  async mounted() {
    this.selectedsubject = this.subjectidpassed;
    this.getsites();
    this.getVisitList();
    this.listSOAs();
    this.getsubject();
  },
  methods: {

    async closeModal() {
      this.$emit("closeformModal");
    },
    async getsites() {
      const idtoken = store.getters.getIdToken;
      const currentstudy = store.getters.getStudyIs;
      await axios
        .get(`${this.baseurl}/management/site/getallsitesbyuser?studyId=${currentstudy}&sortProperty=siteCode&IsDes=false&getAll=false`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.sites = res.data;
          console.log("The sites are", this.sites)
        })
        .catch((err) => {
          console.log(err);
        });
    },
     async getVisitList() {
      const currentstudy = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          // `${this.baseurl}/management/visit/listvisit?StudyId=${currentstudy}`,
           `${this.baseurl}/management/patientschedule/getpatientshedule?patientID=${this.subjectidpassed}&ItemCount=500&sortprop=VisitNo`,

          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log("respp visit", res.data);
          this.visits = res.data.data; // Removed sorting
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // async getVisitList() {
    //   const currentstudy = store.getters.getStudyIs;
    //   const idtoken = store.getters.getIdToken;
    //   await axios
    //     .get(
    //       `${this.baseurl}/management/visit/listvisit?StudyId=${currentstudy}`,

    //       {
    //         headers: {
    //           Authorization: "Bearer " + idtoken,
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     )
    //     .then((res) => {
    //       console.log("respp visit", res.data);
    //       this.visits = res.data.results.sort((a, b) =>
    //         a.visitFormName.localeCompare(b.visitFormName,
    //           undefined,
    //           { numeric: true, sensitivity: "base" }
    //         ));

    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    async isScheduled(subjectid) {
      if (this.selectedvisit === "" || this.selectedactivity === "") {
        alert("Please select visit and activity to map the form");
        return;
      }

      console.log("ScheduleId:", this.ScheduledId);
      console.log("FormId:", this.formid);

      const idtoken = store.getters.getIdToken;

      try {
        await axios.put(
          `${this.baseurl}/management/patientschedule/updateschedulevisitinfo`,
          {
            ScheduleId: this.selectedvisit.sheduleId,
            VisitId: this.selectedactivity.visitId,
            ActivityId: this.selectedactivity.activityId,
            FormId: this.formid,
          },
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        alert("Form mapped successfully");
        this.$emit("formMapped");
        this.closeModal();

      } catch (err) {
        console.error(err);
      }
    },

    async listSOAs(siteId, subjectId, visitNo) {
      console.log("selexted visit",this.selectedvisit);
  const currentstudy = store.getters.getStudyIs;
  const idtoken = store.getters.getIdToken;
  this.activitiesLoading = true;

  try {
    const res = await axios.get(
      // await axios.get(`${this.baseurl}/management/study/listsoa?studyId=${currentstudy}`,
      `${this.baseurl}/management/patientschedule/getactivitynames?subjectId=${subjectId}&visitNo=${visitNo}&studyId=${currentstudy}`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("SoA list", res.data);

    // Adjust based on actual API response shape
    this.SoAList = res.data.data || res.data.entities || [];

  } catch (err) {
    console.error("Error loading activities", err);
  } finally {
    this.activitiesLoading = false;
  }
},
async getAdditionalForms(subjectId) {
      if(this.additionalformchecked[subjectId]){
        this.additionalformchecked[subjectId] = !this.additionalformchecked[subjectId];
      }
      else{
        this.additionalformchecked[subjectId] = true;
      }
      const idtoken = this.$store.getters.getIdToken;
      const stdid = this.$store.getters.getStudyIs;
      try {
        const res = await axios.get(
          `${this.baseurl}/management/patientschedule/getfromsbyvisit`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
            params: {
              studyId: stdid,
              patientID: subjectId,
              visitNo: null,
            },
          }
        );
        // Vue reactivity: use Vue.set or assign directly if using Vue 3
        this.additionalFormObj[subjectId] = res.data.data;
        
        console.log("data is ", this.additionalFormObj[subjectId]);
      } catch (err) {
        console.log("error while getting visit forms list", err);
      }
    },
        async getFormsByVisit() {
 
  const idtoken = store.getters.getIdToken;
  const stdid = store.getters.getStudyIs;

  try {
    const res = await axios.get(
      `${this.baseurl}/management/patientschedule/getfromsbyvisit`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
        params: {
          studyId: stdid,
          patientID: this.subjectidpassed,
          visitNo: this.selectedvisit.visitNo,
          visitName: this.selectedvisit.visitName,
          activityId: this.selectedactivity.activityId,
          activityOrder:this.selectedactivity.activityOrder,
        },
      }
    );
    this.TemplateList = res.data.data;
    console.log("data is ", res.data);
  } catch (err) {
    console.log("error while getting visit forms list", err);
  }
},
    async getsubject() {
      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      await axios
        .get(
          `${this.baseurl}/management/patient/listpatient?Studyid=${currentstudyid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log(res);
          this.subjects = res.data.results;
          this.patientdetails = this.subjects.find(p => p.patientId === this.subjectidpassed);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";
@import "../../assets/savepages.css";

.setheightandwidth {
  height: 80vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.study_profile_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}

.study_profile_modal__container {
  position: fixed;
  width: min(60%, 90%);
  border-radius: 4px;
  background: #fff;
  overflow-x: hidden;
}

.modal__title {
  background-color: var(--pop-up-background);
  color: white;
}

.cancel_btn {
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
}

.import-popup {
  position: relative;
}

.import-popup .tool-tip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 0;
  top: -40px;
  font-size: 0.8rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.import-popup:hover .tool-tip,
.import-popup:focus .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}

.custom-popup {
  text-align: center;
}


.multiselect-template-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
  --ms-radius: 0;
  --ms-line-height: 0.8;
  --ms-option-font-size: 0.8rem;
  --ms-font-size: 0.8rem;
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.custom-tooltip {
  visibility: hidden;
  width: 60px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: -18%;
  /* Position the tooltip above the icon */
  left: -375%;
  margin-left: -30px;
  /* Use half of the width to center-align */
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
}

.tooltip-wrapper:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}

.aboveall {

  z-index: 10000 !important;
}
</style>